export default function warn<T>(t: T) {
  console.warn(t)
  return t
}
